<template>
    <v-app class="homepage homepage-b2b">
        <div class="homepage__container homepage__white homepage__container-header">
            <v-container class="main-block">
                <v-layout wrap row class="homepage__title-layout px-0">
                    <v-flex xs12 md8 class="homepage__title">
                        <h1>Зарабатывайте<br>с каждой продажи ОСАГО до 35%</h1>
                        <info-carousel
                            style="display: none;"
                            :items="slider"
                        />
                    </v-flex>
                    <v-flex xs12 md7 class="homepage__subtitle">
                        <p>
                            Зарабатывайте на продаже ОСАГО, КАСКО и других страховых продуктов до 55% — без офиса,
                            опыта и вложений.<br>
                            Подключайтесь к Getpolis и начните получать доход уже через 24 часа. Всё через одну
                            платформу. Все официально: регистрация на платформе, работа со СК и выплаты КВ.
                        </p>
                    </v-flex>
                    <v-flex xs12 class="buttons-block">
                        <div d-block class="button-block">
                            <v-btn
                                class="button next-button block v-btn"
                                href="https://b2b.getpolis.ru/login?registration"
                            >
                                Стать агентом
                            </v-btn>
                            <span class="text-under-button" style="display: none;">
                                Регистрация займет 1 минуту.
                            </span>
                        </div>
                        <div d-block>
                            <v-btn
                                style="display: none;"
                                class="button prev-button block v-btn"
                                href="https://b2b.getpolis.ru/login"
                            >
                                Войти
                            </v-btn>
                            <p class="text-righter-button">Зарегистрируем и выдадим<br>доступ за 5 минут</p>
                        </div>
                    </v-flex>
                    <div class="flex b2b-green-circle"></div>
                </v-layout>
            </v-container>
            <v-container class="second-block">
                <v-layout class="b2b-slider">
                    <v-carousel
                        hide-delimiters
                    >
                        <v-carousel-item
                            v-for="(item,i) in items"
                            :key="i"
                            :interval="3000"
                            :src="item.src"
                            reverse-transition="fade-transition"
                            transition="fade-transition"
                        ></v-carousel-item>
                    </v-carousel>
                </v-layout>
            </v-container>
        </div>

        <!--Почему более 6000 агентов-->
        <div class="homepage__container homepage__grey">
            <v-container class="homepage__container-why-choose-us" id="chooseContainer">
                <h2 style="display: none">Почему<br>нас выбирают<br><span class="grey-text">14 причин</span></h2>
                <p>Почему более 6000 тысяч агентов выбирают работать и зарабатывать вместе с Getpolis</p>
                <v-layout class="homepage__container-why-choose-us__inner" wrap row>
                    <v-layout class="homepage__container-why-choose-us__block-with-inner" wrap row>
                        <v-flex wrap row id="choose1_1" xs12 md5>
                            <v-flex class="homepage__container-why-choose-us__block">
                                <v-flex xs12 class="homepage__container-why-choose-us__block__column">
                                    <h4>Быстрая выплата комиссионного вознаграждения и даже в праздники</h4>
                                    <p>В течение 24 часов, после оплаты полиса, вы получите КВ</p>
                                </v-flex>
                                <v-flex xs12 class="homepage__container-why-choose-us__block__column">
                                    <h4>Высокий доход и высокая комиссия</h4>
                                    <p>Мы ценим наших агентов, поэтому установили высокое комиссионное вознаграждение, до 55% за продажу полисов.</p>
                                </v-flex>
                                <v-flex xs12 class="homepage__container-why-choose-us__block__column">
                                    <h4>Работа с клиентами по всей РФ</h4>
                                    <p>Оформляйте страховые продукты, для клиентов со всей России, вне зависимости от его прописки или сегмента</p>
                                </v-flex>
                            </v-flex>

                        </v-flex>
                        <v-flex wrap row id="choose1_2" xs12 md7>
                            <v-flex class="homepage__container-why-choose-us__block">
                                <v-flex xs12 class="homepage__container-why-choose-us__block__column">
                                    <h4>Работа из любой<br>точки мира</h4>
                                    <p>
                                        Мы позаботились о наших агентах и разработали личный<br>кабинет, с простым и
                                        понятным интерфейсом. Теперь<br>оформлять полисы стало еще проще и быстрее, в
                                        режиме<br>единого окна
                                    </p>
                                </v-flex>
                                <v-flex xs12 class="homepage__container-why-choose-us__block__column">
                                    <h4>Гибкие и адекватные<br>условия сегментации</h4>
                                    <p>
                                        С нами вы можете быть уверены, что<br>ни один клиент не уйдет
                                        от вас без<br>оформленного полиса.
                                    </p>
                                </v-flex>
                                <v-flex xs12 class="homepage__container-why-choose-us__block__column">
                                    <h4>Индивидуальная<br>поддержка</h4>
                                    <p>За каждым агентом мы закрепляем<br>персонального куратора, который<br>ответит на любые вопросы</p>

                                    <img width="220" src="/img/home/3.png" class="hidden-sm-and-down" style="display: none;"/>
                                    <img src="/img/home/ipad_pro.png" class="right-bottom-float-image hidden-sm-and-down"/>
                                    <img width="280" src="/img/home/ipad_iphone.png" class="right-bottom-float-image hidden-md-and-up"/>
                                </v-flex>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                </v-layout>
            </v-container>
        </div>

        <div class="homepage__container homepage__white">
            <v-container class="homepage__container-who-will-choose-us">
                <h2>Кому подойдёт работа<br>с платформой Getpolis</h2>
                <v-layout class="homepage__container-who-will-choose-us__inner" wrap row>
                    <div class="grid-container">
                        <div class="block block-1">
                            <div class="block__header">
                                <p class="block__header__title">Страховой агент<br>или брокер</p>
                                <p class="block__header__subtitle">Лизинг</p>
                            </div>
                            <div class="block__footer">
                                <p>Страховой агент или брокер<br>Знаете продукт, ищете новые каналы и СК<br>ОСАГО, КАСКО, страхование ипотеки, ВЗР, НС</p>
                            </div>
                        </div>
                        <div class="block block-2">
                            <div class="block__header">
                                <p class="block__header__title">Автомеханик, автосалон,<br>СТО</p>
                                <p class="block__header__subtitle">ОСАГО, КАСКО</p>
                            </div>
                            <div class="block__footer">
                                <p>Постоянный поток клиентов с машинами</p>
                            </div>
                        </div>
                        <div class="block block-3">
                            <div class="block__header">
                                <p class="block__header__title">Риэлтор / ипотечный брокер</p>
                                <p class="block__header__subtitle">ОСАГО, КАСКО</p>
                            </div>
                            <div class="block__footer">
                                <p>Страхование ипотеки (жизни, квартиры)</p>
                            </div>
                        </div>
                        <div class="block block-4">
                            <div class="block__header">
                                <p class="block__header__title">Специалист по техосмотру /<br>диагностики (ТО)</p>
                                <p class="block__header__subtitle">ОСАГО, КАСКО</p>
                            </div>
                            <div class="block__footer">
                                <p>Все клиенты — целевая<br>аудитория для ОСАГО</p>
                            </div>
                        </div>
                        <div class="block block-5">
                            <div class="block__header">
                                <p class="block__header__title">Тренер / владелец спортклуба</p>
                                <p class="block__header__subtitle">НС для спортсменов и детей</p>
                            </div>
                            <div class="block__footer">
                                <p>Полисы НС обязательны для соревнований и секций</p>
                            </div>
                        </div>
                        <div class="block block-6">
                            <div class="block__header">
                                <p class="block__header__title">Турагент / тревел-менеджер</p>
                                <p class="block__header__subtitle">ВЗР, антиклещевые полисы</p>
                            </div>
                            <div class="block__footer">
                                <p>Каждый турист обязан оформлять страховку</p>
                            </div>
                        </div>
                        <div class="block block-7">
                            <div class="block__header">
                                <p class="block__header__title">Просто ищете<br>дополнительный доход</p>
                                <p class="block__header__subtitle"></p>
                            </div>
                            <div class="block__footer">
                                <p>Есть телефон/ноутбук, доступ в интернет,<br>желание зарабатывать<br>Все продукты, без ограничений и опыта</p>
                            </div>
                        </div>
                    </div>

                </v-layout>
            </v-container>

            <v-container class="homepage__container-what-products">
                <h2>Какие продукты вы можете<br>продавать через Getpolis</h2>
                <v-layout class="homepage__container-what-products__inner" wrap row>
                    <div class="homepage__container-what-products__inner-grid">
                        <div class="block block-1">
                            <div class="block__header">
                                <p class="block__header__title">ОСАГО</p>
                                <p class="block__header__subtitle">Обязательное страхование легковых авто</p>
                            </div>
                            <div class="block__footer">
                                <p>500–1500 ₽ за полис</p>
                            </div>
                        </div>
                        <div class="block block-2">
                            <div class="block__header">
                                <p class="block__header__title">ОСАГО на трактор / грузовую технику</p>
                                <p class="block__header__subtitle">Оформление ОСАГО для сельхоз и грузовой техники</p>
                            </div>
                            <div class="block__footer">
                                <p>Повышенное вознаграждение</p>
                            </div>
                        </div>
                        <div class="block block-3">
                            <div class="block__header">
                                <p class="block__header__title">Антиклещ</p>
                                <p class="block__header__subtitle">Страхование от укуса клеща (особенно актуально весной и летом)</p>
                            </div>
                            <div class="block__footer">
                                <p>Быстрая продажа, до 90% КВ</p>
                            </div>
                        </div>
                        <div class="block block-4">
                            <div class="block__header">
                                <p class="block__header__title">Защита от бесполисных</p>
                                <p class="block__header__subtitle">Оформление по VIN / без оригиналов документов</p>
                            </div>
                            <div class="block__footer">
                                <p>Доход выше среднего</p>
                            </div>
                        </div>
                        <div class="block block-5">
                            <div class="block__header">
                                <p class="block__header__title">КАСКО</p>
                                <p class="block__header__subtitle">Оформляется по запросу — через менеджера</p>
                            </div>
                            <div class="block__footer">
                                <p>Индивидуальный расчёт, высокий чек</p>
                            </div>
                        </div>
                        <div class="block block-6">
                            <div class="block__header">
                                <p class="block__header__title">Ипотечное страхование</p>
                                <p class="block__header__subtitle">Для заёмщиков — жизнь и имущество</p>
                            </div>
                            <div class="block__footer">
                                <p>1000–4000 ₽ за полис</p>
                            </div>
                        </div>
                        <div class="block block-7">
                            <div class="block__header">
                                <p class="block__header__title">Лизинг</p>
                                <p class="block__header__subtitle">Страхование ТС в лизинге</p>
                            </div>
                            <div class="block__footer">
                                <p>По договорённости, чек выше среднего</p>
                            </div>
                        </div>
                    </div>
                </v-layout>
            </v-container>

            <v-container class="homepage__container-coming-soon">
                <h2>Скоро появится</h2>
                <div class="homepage__container-coming-soon__block green-gradient">
                    <div class="homepage__container-coming-soon__block__column">
                        <h4>ВЗР (выезд за рубеж)</h4>
                        <p>Отличный сезонный продукт, быстрые продажи</p>
                        <p class="subtext">В разработке</p>
                    </div>
                    <div class="homepage__container-coming-soon__block__column">
                        <h4>Транзитное ОСАГО</h4>
                        <p>Страховка на короткий срок при перерегистрации ТС</p>
                        <p class="subtext">Скоро доступно</p>
                    </div>
                    <div class="homepage__container-coming-soon__block__column">
                        <h4>Банковские продукты</h4>
                        <p>Кредитование, партнёрские фин.услуги, кросс-продажи</p>
                        <p class="subtext">Внедряется</p>
                    </div>
                </div>
            </v-container>
        </div>

        <div class="homepage__container homepage__white homepage__container__overflow-hidden">
            <v-container class="homepage__container-how-it-work">
                <h2>Как начать работать<br>с Getpolis</h2>
                <v-layout wrap row class="homepage__container-how-it-work__list">
                    <v-flex class="homepage__container-how-it-work__list__item" xs12 md6>
                        <v-flex class="homepage__container-how-it-work__list__item__number">1</v-flex>
                        <v-flex class="homepage__container-how-it-work__list__item__text">
                            <h4>Зарегистрируйтесь</h4>
                            <p>Ниже кнопка Регистрация</p>
                        </v-flex>
                    </v-flex>
                    <v-flex class="homepage__container-how-it-work__list__item" xs12 md6>
                        <v-flex class="homepage__container-how-it-work__list__item__number">2</v-flex>
                        <v-flex class="homepage__container-how-it-work__list__item__text">
                            <h4>Получаете доступ к платформе и обучению</h4>
                            <p>Обучение проходит совместно с персональным куратором, в формате индивидуального введения в работу на платформе</p>
                        </v-flex>
                    </v-flex>
                    <v-flex class="homepage__container-how-it-work__list__item" xs12 md6>
                        <v-flex class="homepage__container-how-it-work__list__item__number">3</v-flex>
                        <v-flex class="homepage__container-how-it-work__list__item__text">
                            <h4>Оформляете полисы</h4>
                            <p>В три шага и в одном окне</p>
                        </v-flex>
                    </v-flex>
                    <v-flex class="homepage__container-how-it-work__list__item" xs12 md6>
                        <v-flex class="homepage__container-how-it-work__list__item__number green-background">4</v-flex>
                        <v-flex class="homepage__container-how-it-work__list__item__text">
                            <h4>Получаете вознаграждение</h4>
                            <p>Подключите автоматические выплаты в лк
                                и зарабатывайте на продаже полисов
                                Среднее время оформления ОСАГО: 4 минуты
                                Средняя комиссия — от 500 до 3000₽ за один полис</p>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-flex xs12 class="buttons-block button-single-block">
                    <div d-block class="button-block">
                        <v-btn
                            class="button next-button block v-btn"
                            href="https://b2b.getpolis.ru/login?registration"
                        >
                            Зарегистрироваться
                        </v-btn>
                        <span class="text-under-button" style="color: #00BA57;">
                            Регистрация займет 1 минуту.
                        </span>
                    </div>
                </v-flex>
            </v-container>
        </div>

        <div class="homepage__container homepage__grey">
            <v-container class="homepage__container-why-you-should-work">
                <h2>Почему с нами<br>нужно работать?</h2>
                <v-layout class="homepage__container-why-you-should-work__inner" wrap row>
                    <div class="why-you-should-work-container">
                        <div class="block">
                            <div class="block__item">
                                <div class="block__item__circle"></div>
                                <div class="block__item__text">Подключены крупнейшие страховые компании</div>
                            </div>
                            <div class="block__item">
                                <div class="block__item__circle"></div>
                                <div class="block__item__text">Высокая одобряемость заявок даже с проблемной сегментацией</div>
                            </div>
                            <div class="block__item">
                                <div class="block__item__circle"></div>
                                <div class="block__item__text">Комиссии выше, чем у большинства агрегаторов и возможность продажи дополнительных страховых продуктов</div>
                            </div>
                        </div>
                        <div class="block">
                            <div class="block__item">
                                <div class="block__item__circle"></div>
                                <div class="block__item__text">Индивидуальная поддержка
                                    в чате, если что-то непонятно</div>
                            </div>
                            <div class="block__item">
                                <div class="block__item__circle"></div>
                                <div class="block__item__text">Один личный кабинет — для всех видов страхования</div>
                            </div>
                            <div class="block__item">
                                <div class="block__item__circle"></div>
                                <div class="block__item__text">Стабильная работа сервиса и быстрая техническая поддержка</div>
                            </div>
                        </div>
                    </div>
                </v-layout>
            </v-container>
        </div>

        <div class="homepage__container homepage__white">
            <v-container class="homepage__container-how-get-reward">
                <v-layout wrap row>
                    <v-flex xs12 md6>
                        <h2>Как получить вознаграждение</h2>
                        <p>Мы официально сотрудничаем с лицензированными СК.
                            Мы помогаем урегулировать убытки и внести изменения прям внутри платформы, без посещения офиса СК.
                            Мы не скрываем комиссии.</p>
                        <v-flex class="homepage__container-how-get-reward__green-circle" hidden-sm-and-up>
                            <div class="homepage__container-how-get-reward__green-circle__images">
                                <img src="/png/smiling-face-dollar.png"/>
                                <img src="/png/cool.png"/>
                            </div>
                            <div class="homepage__container-how-get-reward__green-circle__small-text">
                                Вознаграждение с одного <br>полиса
                            </div>
                            <div class="homepage__container-how-get-reward__green-circle__big-text">
                                до 35%
                            </div>
                        </v-flex>
                        <v-flex class="button-block-text">Всё честно. Всё прозрачно. Всё работает.</v-flex>
                        <v-flex class="buttons-block button-single-block button-inline-blocks">
                            <div d-block class="button-block">
                                <v-btn
                                    class="button next-button block v-btn"
                                    href="https://b2b.getpolis.ru/login?registration"
                                >
                                    Зарегистрироваться
                                </v-btn>
                                <span class="text-near-button" style="color: #00BA57;">
                                    Регистрация займет 1 минуту.
                                </span>
                            </div>
                        </v-flex>
                    </v-flex>
                    <v-flex xs12 md6 hidden-sm-and-down>
                        <v-flex class="homepage__container-how-get-reward__green-circle">
                            <div class="homepage__container-how-get-reward__green-circle__images">
                                <img src="/png/smiling-face-dollar.png"/>
                                <img src="/png/cool.png"/>
                            </div>
                            <div class="homepage__container-how-get-reward__green-circle__small-text">
                                Вознаграждение с одного полиса
                            </div>
                            <div class="homepage__container-how-get-reward__green-circle__big-text">
                                до 35%
                            </div>
                        </v-flex>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-container class="homepage__container-join-the-team">
                <v-layout wrap row class="homepage__container-join-the-team__wrapper">
                    <v-flex xs12 md6 class="homepage__container-join-the-team__info-block">
                        <p class="text">Присоединяйтесь к команде Getpolis и зарабатывайте на страховании уже сегодня</p>
                        <p class="subtext">Не нужно заключать договоры со страховыми компаниями — мы это сделали за Вас. Присоединяйтесь к команде наших партнеров и начните зарабатывать уже сегодня. Регистрируйтесь и мы расскажем подробнее</p>
                        <div>
                            <v-btn
                                class="button next-button block v-btn"
                                href="https://b2b.getpolis.ru/login?registration"
                            >
                                Стать агентом
                            </v-btn>
                        </div>
                    </v-flex>
                    <v-flex xs12 md6 class="homepage__container-join-the-team__image-block">
                        <div class="image"></div>
                    </v-flex>
                    <v-flex xs12 class="homepage__container-join-the-team__mobile-button">
                        <div>
                            <v-btn
                                class="button next-button block v-btn"
                                href="https://b2b.getpolis.ru/login?registration"
                            >
                                Стать агентом
                            </v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-container class="homepage__container-reviews">
                <v-layout wrap row class="homepage__container-reviews__wrapper">
                    <div class="homepage__container-reviews__header">
                        <h2>Отзывы действующих<br>агентов</h2>
                        <div class="homepage__container-reviews__header__buttons">
                            <div class="button-left" @click="scrollLeft">
                                <img src="/img/home/arrow-right.svg" alt="left" style="transform: rotate(180deg)">
                            </div>
                            <div class="button-right" @click="scrollRight">
                                <img src="/img/home/arrow-right.svg" alt="right">
                            </div>
                        </div>
                    </div>

                    <div class="homepage__container-reviews__main" ref="reviewsContainer">
                        <div class="review-block" v-for="(item, index) in reviewsArray" :key="index">
                            <div class="review-block__top">
                                <div class="review-block__top__agent">
                                    <p class="name">{{ item.name }}</p>
                                    <p class="city">{{ item.city }}</p>
                                </div>
                                <div class="review-block__top__text">
                                    <p class="text">{{ item.text }}</p>
                                </div>
                            </div>
                            <div class="review-block__bottom">
                                <div class="review-block__bottom__stars">
                                    <div class="star" v-for="(star, index) in item.stars" :key="index">
                                        <img src="/img/home/star.svg" alt="star">
                                    </div>
                                </div>
                                <div class="review-block__bottom__date">
                                    <p class="date">дата</p>
                                    <p>{{ item.date }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-layout>
            </v-container>
        </div>

        <div class="homepage__container homepage__grey" style="display: none;">
            <v-container class="homepage__container-slogan">
                <v-flex class="homepage__slogan">
                    <p>Мы выстроили прямые партнерские отношения с ТОП-страховыми компаниями и предоставили возможность любому человеку продавать полисы онлайн по всей России и получать максимальное вознаграждение с продаж.</p>
                    <p>Не нужно заключать договоры со страховыми компаниями — мы это сделали за Вас.</p>
                </v-flex>
                <v-flex class="homepage__slogan__button-block">
                    <v-btn
                        class="button next-button block v-btn"
                        href="https://b2b.getpolis.ru/login?registration"
                    >
                        Зарегистрироваться
                    </v-btn>
                    <v-flex class="homepage__slogan__button-text">Зарегистрируйся сейчас и восстанавливай КБМ бесплатно.<br class="hidden-sm-and-down">Регистрация займет 1 минуту.</v-flex>
                </v-flex>
            </v-container>
        </div>
        <div class="homepage__container" style="display: none;"
             :showOnMobile = "true"
        >
            <v-container class="homepage__container-slogan" hidden-sm-and-down>
                <osago-partners
                ></osago-partners>
            </v-container>
        </div>
        <div class="homepage__container homepage__grey" style="display: none;">
            <v-container class="homepage__container-why-choose-us" id="chooseContainer">
                <h2>Почему<br>нас выбирают<br><span class="grey-text">14 причин</span></h2>
                <v-layout class="homepage__container-why-choose-us__inner" wrap row>
                    <v-layout class="homepage__container-why-choose-us__block-with-inner" wrap row>
                        <v-flex wrap row id="choose1_1" xs12 md5>
                            <v-flex class="homepage__container-why-choose-us__block">
                                <v-flex xs12 class="homepage__container-why-choose-us__block__column">
                                    <h4>Быстрые выплаты вознаграждений<br>за продажи</h4>
                                    <p>Получайте вознаграждение <br>за полисы на свои реквизиты.</p>
                                </v-flex>
                                <v-flex xs12 class="homepage__container-why-choose-us__block__column">
                                    <h4>Высокий уровень дохода</h4>
                                    <p>Размер комиссионного <br>вознаграждения до 50%</p>
                                </v-flex>
                                <v-flex xs12 class="homepage__container-why-choose-us__block__column">
                                    <h4>Расширенный сегмент территории</h4>
                                    <p>Оформляйте клиентов со всей территории РФ. Не нужно отказывать клиенту, если у него не местная прописка или не проходит сегментацию.</p>
                                </v-flex>
                            </v-flex>

                        </v-flex>
                        <v-flex wrap row id="choose1_2" xs12 md7>
                            <v-flex class="homepage__container-why-choose-us__block">
                                <v-flex xs12 class="homepage__container-why-choose-us__block__column">
                                    <h4 class="main-header">Оформляйте полисы с любых устройств из любой точки мира</h4>
                                    <h4>Все для работы в одном <br>кабинете</h4>
                                    <ul>
                                        <li>Простой и понятный интерфейс.</li>
                                        <li>Формируйте любые отчеты <br>по Вашим полисам.</li>
                                        <li>Мы сохраняем все данные <br>каждые 5 секунд, вы ничего не <br>потеряете.</li>
                                        <li>После оплаты скачайте полис <br>в личном кабинете или получите <br>его на e-mail.</li>
                                    </ul>
                                    <img width="220" src="/img/home/3.png" class="hidden-sm-and-down"/>
                                    <img src="/img/home/ipad_pro.png" class="right-bottom-float-image hidden-sm-and-down"/>
                                    <img width="280" src="/img/home/ipad_iphone.png" class="right-bottom-float-image hidden-md-and-up"/>
                                </v-flex>
                            </v-flex>
                        </v-flex>
                    </v-layout>

                    <v-layout wrap row class="homepage__container-why-choose-us__block green-gradient" id="choose2">
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>Полностью электронный документооборот</h4>
                            <p>Не нужно забирать и отвозить бланки строгой отчетности, акты, квитанции. Не нужно крепить никакие документы. Теперь всё онлайн!</p>
                        </v-flex>
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>Гарантированное оформление полисов</h4>
                            <p>С нами Вы не потеряете ни одного клиента. Если ни одна страховая компания не подтвердила оформление, Ваш персональный менеджер поможет оформить клиента.</p>
                        </v-flex>
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>Техническая поддержка</h4>
                            <p>За каждым агентом закреплен свой персональный менеджер. Возможность обратиться к менеджеру по любому вопросу 24/7, в том числе в телефонном режиме.</p>
                        </v-flex>
                    </v-layout>

                    <v-layout wrap row class="homepage__container-why-choose-us__block margin-mobile" id="choose3">
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <div class="homepage__container-why-choose-us__block__column__images">
                                <img src="/png/alarm-clock.png"/>
                                <img src="/png/woman_raising_hand.png"/>
                            </div>
                            <h4>Экономия Вашего времени</h4>
                            <ul>
                                <li>Данные по ТС, ДК и предыдущему полису подтягиваются по гос. номеру</li>
                                <li>Не нужно крепить фотографии ТС, а также ждать каких-либо cогласований</li>
                            </ul>
                        </v-flex>
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <div class="homepage__container-why-choose-us__block__column__images">
                                <img src="/png/lorry.png"/>
                                <img src="/png/motorcycle.png"/>
                            </div>
                            <h4>Оформляйте грузовики<br>и мотоциклы</h4>
                            <p>Оформляйте ОСАГО на грузовики и мотоциклы легко.</p>
                        </v-flex>
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <div class="homepage__container-why-choose-us__block__column__images">
                                <img src="/png/cool.png"/>
                                <img src="/png/smiling-face-with-heart-eyes.png"/>
                            </div>
                            <h4>Нам доверяют</h4>
                            <p>Более 7000 агентов и партнеров,<br>а также 20 страховых компаний.</p>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap row class="homepage__container-why-choose-us__block white-block margin-mobile" id="choose4">
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>Своя агентская сеть</h4>
                            <p>Создавайте и развивайте свою агентскую сеть. Подключайте агентов и субагентов. Зарабатывайте дополнительное вознаграждение со всех продаж.</p>
                        </v-flex>
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>Надежность</h4>
                            <p>На сайте страховой компании-партнера в разделе «Реестр страховых агентов и брокеров» Вы найдете заключенный с нами договор</p>
                        </v-flex>
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>Улучшенная проходимость полисов</h4>
                            <ul>
                                <li>Интеграции с ГИБДД, РСА, ЕАИСТО.</li>
                                <li>ОСАГО на 3,6,9,12 месяцев.</li>
                            </ul>
                        </v-flex>
                    </v-layout>
                </v-layout>
                <v-flex xs12 class="buttons-block button-single-block">
                    <div d-block class="button-block">
                        <v-btn
                            class="button next-button block v-btn"
                            href="https://b2b.getpolis.ru/login?registration"
                        >
                            Зарегистрироваться
                        </v-btn>
                        <span class="text-under-button">
                            Регистрация займет 1 минуту.
                        </span>
                    </div>
                </v-flex>
            </v-container>
        </div>
        <div class="homepage__container homepage__white" style="display: none;">
            <v-container class="homepage__container-faq">
                <h2>Для кого создан <br>наш сервис</h2>
                <home-questions
                    :faq="serviceQuestions"
                />
                <v-flex class="buttons-block button-single-block" hidden-sm-and-down>
                    <div d-block class="button-block button-inline-blocks">
                        <v-btn
                            class="button next-button block v-btn"
                            href="https://b2b.getpolis.ru/login?registration"
                        >
                            Зарегистрироваться
                        </v-btn>
                        <span class="text-near-button">
                            Регистрация займет 1 минуту.
                        </span>
                    </div>
                </v-flex>
            </v-container>
        </div>
        <div class="homepage__container homepage__white" style="display: none;">
            <v-container class="services">
                <h2 class="text-left">Как с нами можно <br>еще зарабатывать</h2>
                <v-layout class="services-bottom">
                    <v-flex class="services-bottom-block" xs12 md6>
                        <div class="services-bottom-block__item">
                            <img src="/svg/woman-technologist.svg">
                            <img src="/svg/link.svg">
                            <p>Разместите у себя в социальных сетях (инстаграм, вконтакте, фейсбук, одноклассники) нашу ссылку и получайте вознаграждение со всех полисов, которые оформлены Вашими клиентами.</p>
                        </div>
                    </v-flex>
                    <v-flex class="services-bottom-block" xs12 md6>
                        <div class="services-bottom-block__item">
                            <img src="/svg/money-bag.svg">
                            <img src="/svg/desktop-computer.svg">
                            <p>Продавайте через наш сервис под Вашим брендом. Разместите наш виджет у себя на сайте и зарабатывайте на всех продажах Ваших агентов и клиентов.</p>
                        </div>
                    </v-flex>
                </v-layout>
                <v-flex class="buttons-block button-single-block button-inline-blocks">
                    <div d-block class="button-block">
                        <v-btn
                            class="button next-button block v-btn"
                            href="https://b2b.getpolis.ru/login?registration"
                        >
                            Зарегистрироваться
                        </v-btn>
                        <span class="text-near-button">
                            Регистрация займет 1 минуту.
                        </span>
                    </div>
                </v-flex>
            </v-container>
        </div>
        <!-- секция скрыта по задаче 1539 -->
        <div v-if="isVisibleAboutUs" class="homepage__container homepage__grey">
            <v-container class="homepage__container-about-us" id="about-us">
                <h2>О нас</h2>
                <v-layout row wrap>
                    <v-flex xs12 class="homepage__container-about-us__list">
                        <v-flex v-for="(item, key) in aboutUs" :key="key" class="homepage__container-about-us__list__item">
                            <img :src="item.img"/>
                            <div v-html="item.name" class="first-text"></div>
                            <div v-html="item.position" class="second-text"></div>
                        </v-flex>
                    </v-flex>
                    <v-flex xs12 class="homepage__container-about-us__text">
                        <p>
                            Коллектив нашей компании работает в сфере страхования уже более 17 лет и знает все тонкости и тенденции страхового рынка. Компания регулярно расширяет список партнеров и сотрудничает с ведущими представителями страховой сферы по всей России. Долгосрочное взаимовыгодное сотрудничество – вот наша цель.
                        </p>
                    </v-flex>
                </v-layout>
                <v-flex xs12 class="buttons-block button-single-block">
                    <div d-block class="button-block">
                        <div class="text-above-button">Хочу с вами работать!</div>
                        <v-btn
                            class="button next-button block v-btn"
                            href="https://b2b.getpolis.ru/login?registration"
                        >
                            Зарегистрироваться
                        </v-btn>
                        <span class="text-under-button">
                            Регистрация займет 1 минуту.
                        </span>
                    </div>
                </v-flex>
            </v-container>
        </div>
        <div class="homepage__container homepage__white">
            <v-container class="homepage__container-faq">
                <h2>Частые вопросы</h2>
                <home-questions
                    :faq="faq"
                />
                <v-flex class="buttons-block button-single-block" hidden-sm-and-down>
                    <div d-block class="button-block button-inline-blocks">
                        <v-btn
                            class="button next-button block v-btn"
                            href="https://b2b.getpolis.ru/login?registration"
                        >
                            Зарегистрироваться
                        </v-btn>
                        <span class="text-near-button">
                            Регистрация займет 1 минуту.
                        </span>
                    </div>
                </v-flex>
            </v-container>
        </div>
        <div class="homepage__container homepage__white homepage__mobile-grey" style="display: none;">
            <v-container class="homepage__container-faq homepage__container-faq__any-question-inner">
                <v-flex wrap row class="homepage__container-faq__any-question">
                    <h3>Остались вопросы?</h3>
                    <v-flex class="homepage__container-faq__any-question__text">
                        <p>По любым вопросам пишите на <a href="mailto:mail@getpolis.ru">mail@getpolis.ru</a>, или звоните 8 800 201 06 43.<br>Расскажем, проконсультируем.</p>
                        <a class="black-button" @click="openFeedback">Задать вопрос</a>
                    </v-flex>
                </v-flex>
            </v-container>
        </div>
        <div class="homepage__container homepage__white" style="display: none;">
            <v-container class="homepage__container-bottom-button">
                <v-flex class="buttons-block button-single-block">
                    <div d-block class="button-block big-button-block">
                        <v-btn
                            class="button next-button block v-btn big-button"
                            href="https://b2b.getpolis.ru/login?registration"
                        >
                            Стать партнёром Getpolis
                        </v-btn>
                        <span class="text-under-button">
                            Регистрация займет 1 минуту.
                        </span>
                    </div>
                </v-flex>
            </v-container>
        </div>

        <homepage-feedback
            :dialog="dialog"
            @closeFeedback="closeFeedback"
        />
    </v-app>
</template>
<script>
export default {
    data: () => ({
        dialog: false,
        items: [
            {
                src: '/img/b2b_slider/macbook.png',
            },
            {
                src: '/img/b2b_slider/ipad.png',
            },
            {
                src: '/img/b2b_slider/iphone.png',
            },
        ],
        slider: [
            {
                text: 'Нам уже доверяют более 7000 агентов и партнеров',
                img: [
                    '/png/face_with_glasses.png',
                    '/png/handshake.png'
                ]
            },
            {
                text: 'ОСАГО и ИПОТЕКА без отказов страховых компаний',
                img: [
                    '/png/cool.png',
                    '/png/check.png'
                ]
            },
            {
                text: 'Начало действия полисов ОСАГО на следующий день, а полисов ИПОТЕКИ в день оформления',
                img: [
                    '/png/red_car.png',
                    '/png/calendar.png'
                ]
            },
            {
                text: 'Автозаполнение данных',
                img: [
                    '/png/robot.png',
                    '/png/hand-with-pen.png'
                ]
            },
            {
                text: 'Оформление всех категорий ТС<br>и видов недвижимости',
                img: [
                    '/png/lorry.png',
                    '/png/motorcycle.png'
                ]
            },
            /*{
                text: 'Бесплатное восстановление КБМ',
                img: [
                    '/png/woman_raising_hand.png',
                    '/png/numbers.png'
                ]
            },*/
        ],
        serviceQuestions: [
            {
                question: 'У Вас своя агентская сеть',
                answer: 'Создавайте и развивайте свою агентскую сеть. Подключайте агентов и субагентов. <br class="hidden-sm-and-down">Зарабатывайте вознаграждение с продаж своей сети.',
            },
            {
                question: 'Вы страховой агент или брокер',
                answer: 'Теперь не нужно заключать договоры с несколькими компаниями. Достаточно зарегистрироваться у нас за 1 минуту и сравнить предложения по 20 компаниям. Зарабатывайте дополнительное вознаграждение со всех продаж.',
            },
            {
                question: 'Вы в поисках дополнительного заработка',
                answer: 'Зарегистрируйтесь у нас за 1 минуту и оформляйте полисы своим друзьям и знакомым. Зарабатывайте с каждой продажи до 35%. Для того, чтобы продавать ОСАГО не нужны специальные навыки или образование.',
            },
            {
                question: 'Вы работаете или связаны с автобизнесом',
                answer: 'Предоставляйте вашим клиентам дополнительную услугу – покупка полиса ОСАГО. Зарегистрируйтесь за 1 минуту и оформляйте ОСАГО просто. Разместите наш виджет у себя на сайте или в мобильном приложении и зарабатывайте до 35% с продаж Вашим клиентам.',
            },
            {
                question: 'Вы собственник сайта по тех осмотрам или КБМ',
                answer: 'Установите наш виджет у себя на сайте или в мобильном приложении и зарабатывайте до 35% с продаж Вашим клиентам.',
            },
            {
                question: 'Вы являетесь собственником или сотрудником станции техосмотра',
                answer: 'Предоставляйте вашим клиентам дополнительную услугу – покупка полиса ОСАГО. Зарегистрируйтесь за 1 минуту и оформляйте ОСАГО просто. Выгружайте всю статистику по продажам и любые отчеты.',
            },
            {
                question: 'Вы собственник сайта или приложения с большим трафиком посетителей',
                answer: 'Установите наш виджет у себя на сайте или в мобильном приложении и получайте дополнительный доход до 35% с каждого проданного полиса через ваш сайт или приложение.',
            },
            {
                question: 'Вы работаете в сфере недвижимости или с этой сферой связаны',
                answer: 'Предоставляйте вашим клиентам дополнительную услугу – покупку ипотечного страхового полиса. Зарегистрируйтесь за 1 минуту и оформляйте ипотечные полисы просто. Разместите наш виджет у себя на сайте или в мобильном приложении и зарабатывайте до 50% с продаж Вашим клиентам.',
            },
        ],
        faq: [
            {
                question: 'Как работает Getpolis?',
                answer: 'Наша платформа сравнивает для Вас цены по всем ТОП страховым компаниям. Вам остается только выбрать наиболее подходящие предложение, оплатить и распечатать страховой полис.'
            },
            {
                question: 'Как начать работу?',
                answer: 'Просто зарегистрируйтесь у нас на сайте за 1 минуту и начинайте продажи.'
            },
            {
                question: 'Кому подойдет наш сервис?',
                answer: 'Наш сервис подойдет Вам, если: <ul>' +
                    '<li>у Вас своя агентская сеть</li>' +
                    '<li>Вы страховой агент или брокер</li>' +
                    '<li>Вы в поисках дополнительного заработка</li>' +
                    '<li>Вы работаете или связаны с автобизнесом</li>' +
                    '<li>Вы собственник сайта по тех осмотрам или КБМ</li>' +
                    '<li>Вы работаете в сфере недвижимости или с этой сферой связаны</li>' +
                    '<li>Вы являетесь собственником или сотрудником станции техосмотра</li>' +
                    '<li>Вы собственник сайта или приложения с большим трафиком посетителей</li>' +
                    '</ul>'
            },
            {
                question: 'Сколько времени потребуется?',
                answer: 'Регистрация занимает не более 1-ой минуты, а оформление договора ОСАГО или ИПОТЕКИ не более 5-ти.'
            },
            {
                question: 'Какие договоры можно заключать?',
                answer: 'На платформе доступно оформление ОСАГО и ИПОТЕКИ. Остальные продукты в процессе реализации, но Ваш персональный куратор поможет Вам в ручном режиме оформить любой страховой продукт.'
            },
            {
                question: 'Как получать выплаты?',
                answer: 'Самозанятые и физлица могут вывести деньги на банковскую карту. Юридические лица и ИП получают вознаграждение на расчетные счета.'
            },
            {
                question: 'В каких регионах можно страховать?',
                answer: 'Оформляйте клиентов со всей территории РФ. Не нужно отказывать клиенту, если у него не местная прописка или не проходит сегментацию.'
            },
        ],
        aboutUs: [
            {
                img: '/img/home/about_us/1.png',
                name: 'Саркисян Армен',
                position: 'Генеральный директор'
            },
            {
                img: '/img/home/about_us/2.png',
                name: 'Маркусов Михаил',
                position: 'Директор по развитию'
            },
            {
                img: '/img/home/about_us/3.png',
                name: 'Вяткин Игорь',
                position: 'Региональный менеджер'
            },
            {
                img: '/img/home/about_us/4.png',
                name: 'Черкасов Александр',
                position: 'Региональный менеджер'
            },
            {
                img: '/img/home/about_us/5.png',
                name: 'Нуралиев Руслан',
                position: 'Региональный менеджер'
            },
            {
                img: '/img/home/about_us/6.png',
                name: 'Махонин Максим',
                position: 'Региональный менеджер'
            },
            {
                img: '/img/home/about_us/7.png',
                name: 'Кочмарь Артём',
                position: 'Региональный менеджер'
            },
            {
                img: '/img/home/about_us/8.png',
                name: 'Варданян Юлия',
                position: 'Поддержка агентов В2В'
            },
            {
                img: '/img/home/about_us/9.png',
                name: 'Ковальчук Алина',
                position: 'Поддержка агентов В2В'
            },
            {
                img: '/img/home/about_us/10.png',
                name: 'Снигур Мария',
                position: 'Поддержка агентов В2С'
            },
        ],
        isVisibleAboutUs:false,
        reviewsArray: [
            {
                name: 'Денис, 36 лет',
                city: 'Нижний Новгород',
                text: 'Был в трёх агрегаторах. Только здесь пошёл поток: без отказов, без багов. \n' +
                    'За день 5 полисов — 4100₽ на карте.',
                stars: 5,
                date: '28.05.2024',
            },
            {
                name: 'Светлана',
                city: 'Агент из Ростова',
                text: 'Клиент заплатил — я сразу вижу деньги. Поддержка помогает, не исчезают. Всё чётко.',
                stars: 5,
                date: '29.05.2024',
            },
            {
                name: 'Игорь, 34 года',
                city: 'Москва',
                text: 'Я не агент, но оформляю по 5–6 полисов в день. Гетполис — как раз то, чего не хватало. Всё чётко.',
                stars: 5,
                date: '30.05.2024',
            },
            {
                name: 'Максим, 28 лет',
                city: 'Екатеринбург',
                text: 'Работал через другую платформу — постоянные отказы. Здесь — стабильно. Первый день — 3 полиса, 2700₽ на карту.',
                stars: 5,
                date: '30.05.2024',
            },
        ],
        regaliaArray: [
            {
                logo: '/img/home/regalia/logo-skolkovo.svg',
                text: `Участник фонда "Сколково"<br>Регистрационный номер №1127664`,
            },
            {
                logo: '/img/home/regalia/logo-mincifry.png',
                text: `В реестре аккредитованных<br>ИТ-компаний №48867`,
            },
            {
                logo: '/img/home/regalia/logo-rospatent.png',
                text: `Регистрация ПО в Роспатенте:<br>№2022617332`,
            },
            {
                logo: '/img/home/regalia/logo-reestr-po.png',
                text: `Реестр российского ПО<br>№2022617332`,
            },
        ],
        touchStartX: 0,
        touchEndX: 0,
    }),
    methods: {
        openFeedback() {
            this.dialog = true
        },
        closeFeedback() {
            this.dialog = false
        },
        scrollLeft() {
            const container = this.$refs.reviewsContainer;
            const blockWidth = container.children[0].offsetWidth + 16; // 16 — твой gap
            if (container.scrollLeft <= 0) {
                container.scrollLeft = container.scrollWidth;
            }
            container.scrollLeft -= blockWidth;
        },
        scrollRight() {
            const container = this.$refs.reviewsContainer;
            const blockWidth = container.children[0].offsetWidth + 16;
            if (container.scrollLeft + container.offsetWidth >= container.scrollWidth) {
                container.scrollLeft = 0;
            } else {
                container.scrollLeft += blockWidth;
            }
        },
        handleTouchStart(e) {
            this.touchStartX = e.changedTouches[0].screenX;
        },
        handleTouchEnd(e) {
            this.touchEndX = e.changedTouches[0].screenX;
            this.handleSwipe();
        },
        handleSwipe() {
            if (this.touchEndX < this.touchStartX - 50) {
                this.scrollRight();
            }
            if (this.touchEndX > this.touchStartX + 50) {
                this.scrollLeft();
            }
        }
    },
    mounted() {
        let aboutLinks = [...document.getElementsByClassName('about-us-link')]
        let aboutBlock = document.getElementById('about-us')
        aboutLinks.forEach((link) => {
            link.setAttribute('href', '#about-us')
            link.addEventListener('click', (e) => {
                e.preventDefault()
                aboutBlock.scrollIntoView({behavior: "smooth"})
            })
        })
        const container = this.$refs.reviewsContainer;
        container.addEventListener("touchstart", this.handleTouchStart);
        container.addEventListener("touchend", this.handleTouchEnd);
    },
    beforeDestroy() {
        const container = this.$refs.reviewsContainer;
        container.removeEventListener("touchstart", this.handleTouchStart);
        container.removeEventListener("touchend", this.handleTouchEnd);
    },
}
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/B2bLanding.vue